import { Directive, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { hasRootAccess } from 'app/store/login/logged-user/logged-user.selectors';
import { selectFirst } from 'core/utils/rx-common';

@Directive({
  selector: '[isRoot]',
  standalone: false,
})
export class IsRootDirective implements OnInit {
  constructor(
    private viewContainerRef: ViewContainerRef,
    private templateRef: TemplateRef<any>,
    private store$: Store,
  ) {}

  ngOnInit(): void {
    this.store$.pipe(selectFirst(hasRootAccess))
      .subscribe((access) => {
        if (!access) {
          this.viewContainerRef.clear();
          return;
        }

        this.viewContainerRef.createEmbeddedView(this.templateRef);
      });
  }
}
